// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  CORS_DOMAIN: '*.eyclienthub.com',
  API_APP_PATH: ' https://eydna-cdp-api-dev.sbp.eyclienthub.com',
  APP_CDN: 'https://eydna-cdp-web-preprod.sbp.eyclienthub.com/',
  appInsights: {
    instrumentationKey: '3cddfd02-ed29-4625-999a-702c923cee47',
    url: 'https://portal.azure.com/#@EYGS.onmicrosoft.com/resource/subscriptions/b1a24b8f-e60a-4e8d-a7ef-e8a453f85ed7/resourceGroups/USSDEYVNGDRSG01/providers/Microsoft.Insights/components/USSDEYVNGDINS01/overview'
  },
  oAuthConfig: {
    issuer: ' https://eydna-cdp-api-dev.sbp.eyclienthub.com',
    clientId: 'Api_App',
    dummyClientSecret: '1q2w3e*',
    scope: 'Api offline_access',
    showDebugInformation: true,
    oidc: false,
    requireHttps: true
  },
  refreshTokenLifetime: 600,
  sessionPropEncKey: 'se55i0nprop10kl1',
  API_AUTH_PATH : 'https://eydna-cdp-api-dev.sbp.eyclienthub.com',
  AUTH_MODE: 'SAML_AZURE' //'SAML_AZURE' 'REPO'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
